import { getAccessToken } from './authService'

const API_URL = import.meta.env.VITE_API_URL

export interface ChatMessage {
  role: 'user' | 'assistant'
  content: string
  sources?: Array<{ source_name: string; page: number }>
}

export interface ChatResponse {
  answer: string
  sources: Array<{ source_name: string; page: number }>
  model: string
}

export async function sendMessage(question: string): Promise<ChatResponse> {
  const token = await getAccessToken()

  const response = await fetch(`${API_URL}/chat`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ question }),
  })

  if (response.status === 401) {
    // Redirect to login on unauthorized
    window.location.href = '/login'
    throw new Error('Unauthorized')
  }

  if (!response.ok) {
    const error = await response.json().catch(() => ({ error: 'Unknown error' }))
    throw new Error(error.error || 'Chat API error')
  }

  return response.json()
}
